<template>
  <PageOne/>
  <PageTwo/>
  <PageThree/>
</template>

<script>
import PageOne from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/SimanTehran/PageOne.vue';
import PageTwo from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/SimanTehran/PageTwo.vue';
import PageThree from '@/components/PerformanceManagement/EconomicOperationReport/Holdings/KavehPars/Companies/SimanTehran/PageThree.vue';

export default {
  components: {
    PageOne,
    PageTwo,
    PageThree,
  },
  data() {
    return {}
  }
}
</script>
